import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { CtaButton } from "./Primitives";

const LINKS = [["Results", "results"], ["System", "system"], ["Founder", "founder"], ["Pricing", "pricing"], ["FAQ", "faq"]];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <motion.header
      data-testid="nav-header"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed inset-x-0 top-0 z-50 px-3 pt-3 sm:px-6"
    >
      <div className={`mx-auto flex max-w-7xl items-center justify-between rounded-full px-4 py-2.5 transition-colors duration-500 sm:px-5 ${scrolled ? "border border-ink/10 bg-paper/80 shadow-[0_10px_40px_-20px_rgba(11,18,32,0.35)] backdrop-blur-xl" : "border border-transparent"}`}>
        <button data-testid="nav-logo" onClick={() => window.__lenis?.scrollTo(0)} aria-label="Coenzio home"><Logo /></button>
        <nav className="hidden items-center gap-1 lg:flex">
          {LINKS.map(([label, id]) => (
            <button key={id} data-testid={`nav-link-${id}`} onClick={() => go(id)} className="rounded-full px-4 py-2 text-[14px] font-medium text-ink/70 transition-colors hover:bg-ink/5 hover:text-ink">{label}</button>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <CtaButton testId="nav-cta-button" className="hidden !py-1.5 sm:inline-flex">Book a fit call</CtaButton>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="grid h-10 w-10 place-items-center rounded-full border border-ink/15 lg:hidden" aria-label="Menu">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div data-testid="nav-mobile-menu" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} className="mx-auto mt-2 max-w-7xl rounded-3xl border border-ink/10 bg-paper/95 p-4 backdrop-blur-xl lg:hidden">
            {LINKS.map(([label, id]) => (
              <button key={id} data-testid={`nav-mobile-link-${id}`} onClick={() => go(id)} className="block w-full border-b border-ink/5 py-3 text-left font-display text-2xl text-ink last:border-0">{label}</button>
            ))}
            <CtaButton testId="nav-mobile-cta" className="mt-4 w-full justify-between">Book a fit call</CtaButton>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
